module.exports = __webpack_public_path__ + "static/media/gif.6eb1ed89.gif";